import root from './event.package.config';
const EventMessage = root.eventpackage.EventMessage;
let msgId = 1;
function isPrimitive(typeName) {
  return ['undefined', 'number', 'string', 'boolean', 'bigint'].includes(typeName);
}
const typeEnum = { string: 0, number: 1, bigint: 2, boolean: 3, symbol: 4, undefined: 5, object: 6, function: 7 };
/**
 * 消息打包器
 */
export class MessagePackager {
  /**
   * 编码事件消息
   */
  encodeEventMessage(toUserId, data) {
    let cloneData = JSON.parse(JSON.stringify(data));
    cloneData.args.forEach((element, index) => {
      let val = element;
      let typeName = typeof element;
      if (!isPrimitive(typeName)) {
        val = JSON.stringify(val);
      } else {
        val = String(val);
      }
      cloneData.args[index] = {
        type: typeEnum[typeName],
        value: val,
      };
    });
    const msg = EventMessage.create({ msgId: msgId++, toUserId, data: cloneData });
    const buffer = EventMessage.encode(msg).finish();
    return buffer;
  }
  /**
   *  解码事件消息
   * @param {*} buffer
   * @returns
   */
  decodeEventMessage(buffer) {
    const msg = EventMessage.decode(new Uint8Array(buffer));
    const obj = EventMessage.toObject(msg);
    if (obj.data && obj.data.args && obj.data.args.length > 0) {
      obj.data.args.forEach((element, index) => {
        let val = element.value;
        if (![0, 5].includes(element.type)) {
          val = JSON.parse(val);
        }
        obj.data.args[index] = val;
      });
    }
    return obj;
  }
}
